import React, { useEffect, useContext, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  CContainer,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilMenu, cilLanguage, cifGb, cifDe, cifIt, cifFr } from '@coreui/icons'

import { AppBreadcrumb } from './index'

import { AppHeaderDropdown } from './header/index'
import { AuthContext } from 'src/contexts/authContext'

const AppHeader = () => {
  const headerRef = useRef()
  const { i18n, t } = useTranslation()
  const { role } = useContext(AuthContext)

  const dispatch = useDispatch()
  const asideShow = useSelector((state) => state.asideShow)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  const currentLocation = useLocation().pathname
  const pathSegments = currentLocation.split('/').filter((segment) => segment !== '')

  useEffect(() => {
    if (pathSegments.includes('tender-detail-view')) {
      dispatch({ type: 'set', sidebarShow: true })
    }

    document.addEventListener('scroll', () => {
      headerRef.current &&
        headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0)
    })
  }, [pathSegments])

  return (
    <CHeader position='sticky' ref={headerRef}>
      <CContainer className='border-bottom' fluid>
        <CHeaderNav className='d-none d-md-flex'>
          <CNavItem>
            <CNavLink href='/tender-overview' className='text-capitalize'>
              {t('TenderOverview.pageTitle')}
            </CNavLink>
          </CNavItem>
          <CNavItem>
            {role == 'devis_admin' && (
              <CNavLink href='/admin-overview' className='text-capitalize'>
                {t('AdminDashboard.pageTitle')}
              </CNavLink>
            )}
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className='ms-auto'>
          <li className='nav-item py-2 py-lg-1'>
            <div className='vr h-100 mx-2 text-body text-opacity-75'></div>
          </li>
          <CDropdown variant='nav-item' placement='bottom-end'>
            <CDropdownToggle caret={false}>
              <CIcon className='my-1' icon={cilLanguage} size='lg' />
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                active={i18n.language === 'de'}
                className='d-flex align-items-center'
                component='button'
                onClick={() => i18n.changeLanguage('de')}
              >
                <CIcon className='me-2' icon={cifDe} size='lg' /> {t('Global.Language.German')}
              </CDropdownItem>
              <CDropdownItem
                active={i18n.language === 'fr'}
                className='d-flex align-items-center'
                component='button'
                onClick={() => i18n.changeLanguage('fr')}
              >
                <CIcon className='me-2' icon={cifFr} size='lg' /> {t('Global.Language.French')}
              </CDropdownItem>
              <CDropdownItem
                active={i18n.language === 'it'}
                className='d-flex align-items-center'
                component='button'
                onClick={() => i18n.changeLanguage('it')}
              >
                <CIcon className='me-2' icon={cifIt} size='lg' /> {t('Global.Language.Italian')}
              </CDropdownItem>
              <CDropdownItem
                active={i18n.language === 'en'}
                className='d-flex align-items-center'
                component='button'
                onClick={() => i18n.changeLanguage('en')}
              >
                <CIcon className='me-2' icon={cifGb} size='lg' /> {t('Global.Language.English')}
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
          <li className='nav-item py-2 py-lg-1'>
            <div className='vr h-100 mx-2 text-body text-opacity-75'></div>
          </li>
        </CHeaderNav>
        <CHeaderNav>
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
      <CContainer fluid>
        <AppBreadcrumb />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
